import { Injectable } from "@angular/core";
import { appState } from "src/app/core/state";

@Injectable()
export class MemberStorageService {
  setItem(key: string, value: string): void {
    localStorage.setItem(this.buildKey(key), value);
  }

  getItem(key: string): string | null {
    return localStorage.getItem(this.buildKey(key));
  }

  getItemOrDefault<T>(key: string, defaultValue: T): T {
    const item = this.getItem(key);
    if (item === null) {
      return defaultValue;
    }

    return JSON.parse(item) as T;
  }

  private buildKey(key: string): string {
    if (!appState.member?.id) {
      return key;
    }

    return `${key}-${appState.member!.id}`;
  }
}
